import { disconnectCommunityStreamUser } from '../services/getstream/streamRealtime';

export async function clearAllLocalLogoutData() {
  await disconnectCommunityStreamUser();
  localStorage.clear();
  sessionStorage.clear();
}
